import { useEffect, useState, type RefObject } from 'react'

/** Masonry column count from container width: 1 on phones, 2–4 on wider screens (SPEC §7.1). */
export function useColumns(ref: RefObject<HTMLElement | null>): number {
  const [cols, setCols] = useState(() => (typeof window === 'undefined' ? 1 : pick(window.innerWidth)))
  useEffect(() => {
    const el = ref.current
    if (!el) return
    const ro = new ResizeObserver(([e]) => setCols(pick(e!.contentRect.width)))
    ro.observe(el)
    return () => ro.disconnect()
  }, [ref])
  return cols
}

function pick(w: number) {
  if (w < 620) return 1
  if (w < 980) return 2
  if (w < 1320) return 3
  return 4
}

/** Greedy shortest-column distribution by estimated height (keeps order roughly row-major). */
export function distribute<T>(items: T[], cols: number, height: (t: T) => number): T[][] {
  const out: T[][] = Array.from({ length: cols }, () => [])
  const h = new Array(cols).fill(0) as number[]
  for (const it of items) {
    let best = 0
    for (let i = 1; i < cols; i++) if (h[i]! < h[best]! - 40) best = i
    out[best]!.push(it)
    h[best]! += height(it)
  }
  return out
}
